import React, { useEffect } from 'react'
import styles from "./SumOfAllBoxAmount.styles"

import Label from '../../../../components/label/Label'
import TextInput from '../../../../components/input/textinput/TextInput'
import Popup from '../../../../components/popup/Popup'
import Loadable from '../../../../components/loadable/Loadable'
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks'

import { Col, Container, Row } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { sumOfAllBoxAmounts } from './SumOfAllBoxAmountSaga'
import { componentKey } from './SumOfAllBoxAmountSlice'
import { PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../../constants/constants'

const SumOfAllBoxAmount = ({ isOpen = false, onCloseCb = () => { }, payerId = "", taxYearId = "", formId = "", Corrected = "", status = "NotSubmitted" }) => {
	useGarbageCollector(componentKey);

	const { loadingState, sumOfAllBoxAmount } = useSelector(state => state[componentKey]);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(sumOfAllBoxAmounts({ payerId, taxYearId, formId, Corrected, status }))
	}, [])

	const Body = (
		<Loadable currentState={loadingState.state} loadingStates={PAGE_STATE.LOADING} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
			<Container>
				<Row style={styles.rowsGap}>
					{sumOfAllBoxAmount?.Boxes?.map(data =>
						<Col md={6}>
							<Label>{data?.Text}</Label>
							<TextInput placeHolder={data?.Text} value={data?.Value} disabled showDisabledStyles />
						</Col>
					)}
				</Row>
			</Container>
		</Loadable>
	)

	return (
		<Popup
			isPopupOpen={isOpen}
			title={`Sum of all ${sumOfAllBoxAmount?.FormType || ''} box amounts`}
			onCloseCb={onCloseCb}
			children={Body}
			childrenStyles={styles.popupBody}
		/>
	)
}

export default SumOfAllBoxAmount
